import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';

import {
  isMobile,
} from "react-device-detect";

const offMarketRows = [
  {
    id: 'status', disablePadding: false, label: 'Status',
  },
  {
    id: 'address_2_normalized', disablePadding: false, label: 'Address',
  },
  {
    id: 'owner', disablePadding: false, label: 'Owner',
  },
  {
    id: 'off_market_date', disablePadding: false, label: 'Off-Market Date',
  },
  {
    id: 'off_market_type', disablePadding: false, label: 'Type',
  },
  {
    id: 'days_on_market', disablePadding: false, label: 'Days on Market',
  },
  {
    id: 'last_listed_sale_price_all', disablePadding: false, label: 'Last Ask',
  },
  {
    id: 'broker', disablePadding: false, label: 'Broker',
  },
  {
    id: 'bedrooms', disablePadding: false, label: 'Beds',
  },
  {
    id: 'baths', disablePadding: false, label: 'Baths',
  },
  {
    id: 'offering_sq_ft', disablePadding: false, label: 'Size',
  },
];

const onMarketRows = [
  {
    id: 'status', disablePadding: false, label: 'Status',
  },
  {
    id: 'address_2_normalized', disablePadding: false, label: 'Address',
  },
  {
    id: 'owner', disablePadding: false, label: 'Owner',
  },
  {
    id: 'last_listed_sale_date_formatted', disablePadding: false, label: 'Listed Date',
  },
  {
    id: 'last_listed_sale_date_all', disablePadding: false, label: 'Days on Market',
  },
  {
    id: 'last_listed_sale_price_all', disablePadding: false, label: 'Asking Price',
  },
  {
    id: 'broker', disablePadding: false, label: 'Broker',
  },
  {
    id: 'bedrooms', disablePadding: false, label: 'Beds',
  },
  {
    id: 'baths', disablePadding: false, label: 'Baths',
  },
  {
    id: 'offering_sq_ft', disablePadding: false, label: 'Size',
  },
];

class ExpiredListingsTableHead extends PureComponent {
  static propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    rtl: RTLProps.isRequired,
  };

  createSortHandler = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick, order, orderBy, numSelected, rowCount, rtl, searchMode,
    } = this.props;

    let rows = searchMode === "on_market" ? onMarketRows.slice() : offMarketRows.slice();
    if (isMobile) rows.splice(0, 1);

    return (
      <TableHead>
        <TableRow>
          <TableCell className="material-table__cell" padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected > 0 && numSelected >= rowCount}
              onClick={onSelectAllClick}
              className={`material-table__checkbox`}
            />
          </TableCell>
          {rows.map(row => (
            <TableCell
              className="material-table__cell material-table__cell--sort material-table__cell-right"
              key={row.id}
              align={rtl.direction === 'rtl' ? 'right' : 'left'}
              padding={row.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === row.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={this.createSortHandler(row.id)}
                className="material-table__sort-label"
                dir="ltr"
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
          ), this)}
        </TableRow>
      </TableHead>
    );
  }
}

export default connect(state => ({
  rtl: state.rtl,
}))(ExpiredListingsTableHead);
